<template>
  <v-container>
    <v-data-table
        loading-text="Loading..."
        class="elevation-0 mb-2"
        :loading="loadingContacts"
        :headers="headersContacts"
        :items="favoriteContacts"
        :options.sync="paginationContacts"
        :footer-props="footerOptions"
        :page.sync="currentPage"
        :server-items-length="totalItems"
        :items-per-page-options="rowsPerPageItems"
        :no-data-text="$route.name === 'MyCompany' ? languageData.noDataAvailable : languageData.noDataFavoriteContactsText"
        mobile-breakpoint="0"
    >
       <template v-slot:item.actions="{ item }">
          <template>
            <v-tooltip top v-if="layout !== 'sendEmail'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    @click="editContact(item.id)"
                    icon>
                  <v-icon color="fontDefault">edit</v-icon>
                </v-btn>
              </template>
              <span>{{ languageData.operation.edit }}</span>
            </v-tooltip>
            <v-tooltip top v-if="layout != 'sendEmail'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    @click="showDeleteFavoriteContactModal(item)">
                  <v-icon color="fontDefault">delete</v-icon>
                </v-btn>
              </template>
              <span>{{ languageData.operation.delete }}</span>
            </v-tooltip>
          </template>
          <template v-if="layout === 'sendEmail'">
            <v-btn
                v-if="emailType === 'invoice'"
                color="primary"
                @click="sendEmail(item)"
                :loading="(item === dataSendIsFetching[dataSendIsFetching.indexOf(item)] && emailType === 'invoice')"
            >
              {{ languageData.labels.send }}
            </v-btn>
            <v-btn
                v-else-if="emailType === 'vobDocument'"
                color="primary"
                @click="sendEmail(item)"
                :loading="(item.email === vobSendIsFetching[vobSendIsFetching.indexOf(item.email)] && emailType === 'vobDocument')"
            >
              {{ languageData.labels.send }}
            </v-btn>
            <v-btn
                v-else
                color="primary"
                @click="sendEmail(item)"
                :loading="(item === dataTimeReportSendIsFetching[dataTimeReportSendIsFetching.indexOf(item)] && emailType === 'timeReport')"
            >
              {{ languageData.labels.send }}
            </v-btn>
          </template>
        </template>
    </v-data-table>
    <ModalInfo 
        v-if="layout != 'sendEmail'"
        :visDisAgreeBtn="true"
        @doOperation="removeContact(favoriteContacts.indexOf(contactToDelete), contactToDelete.id)"
        :typeInfo="'info'" :btnDisAgreeText="languageData.btnDisAgreeText"
        :headModal="languageData.modalDeleteContact.head" :btnAgreeText="languageData.btnAgreeText"
        @clicked="hideModalContact" :show-modal="isShowModalDeleteFavoriteContact"
        :text-modal="languageData.modalDeleteContact.textInfo + ' ' + contactToDelete.firstname + ' ' + contactToDelete.lastname">
    </ModalInfo>
    <ModalInfo v-if="layout" :hidden-agree-btn="true" :layout="'sendEmailForm'" @clicked="hideSendDocumentForm" :show-modal="showSendDocumentFormModal">
      <template v-slot:header>
          {{ languageData.documents.sendDocument + ' ' + document.id + ' ' + languageData.documents.sendTo + ' ' + favoriteContact.email}}
      </template>
      <template v-slot:body>
        <SendDocumentForm :clientPerson="favoriteContact"></SendDocumentForm>
      </template>
    </ModalInfo>
  </v-container>
</template>

<script type="text/javascript">
import {mapActions, mapState} from "vuex";
import ModalInfo from "../../../../components/ModalInfo/ModalInfo";
import eventBus from "../../../../event-bus/eventBus";
import SendDocumentForm from "../../../Documents/components/SendDocumentForm/SendDocumentForm";

export default {
  name: "FavoriteContactsTable",
  props: {
    layout: String,
    emailType: String
  },
  components: {
    ModalInfo, SendDocumentForm
  },
  data() {
    return {
      footerOptions: {
        'items-per-page-options': [5, 15, 30],
        'disablePagination': false
      },
      currentPage: 1,
      favoriteContacts: [],
      contactToDelete: {},
      updatedContact: {},
      contactIcons: [],
      showAddContactToEntriesModal: false,
      favoriteContact: {},
      showSendDocumentFormModal: false
    }
  },
  computed: {
    ...mapState("getFavoriteContacts", {
      favoriteContactsReceive: state => state.dataReceive,
      totalItems: state => state.pagination.totalItems,
      rowsPerPageItems: state => state.pagination.rowsPerPage,
      headers: state => state.headers,
      sortBy: state => state.pagination.sortBy,
      loadingContacts: state => state.loadingContacts
    }),
    ...mapState("deleteFavoriteContact", {
      isShowModalDeleteFavoriteContact: state => state.isShowModalDeleteFavoriteContact
    }),
    ...mapState("getHeadersFavoriteContacts", {
      headersContacts: state => state.headers
    }),
    ...mapState("updateVisibleFavoriteContactFormModal", {
        isShowFavoriteContactFormModal: state => state.isShowFavoriteContactFormModal
    }),
    ...mapState("sendInvoice", {
      invoice: state => state.invoice,
      dataSendIsFetching: state => state.dataSendIsFetching
    }),
     ...mapState("sendTimeReport", {
      timeReport: state => state.timeReport,
      dataTimeReportSendIsFetching: state => state.dataTimeReportSendIsFetching
    }),
    ...mapState("sendDocument", {
      document: state => state.document,
      dataSendDocumentIsFetching: state => state.dataSendDocumentIsFetching
    }),
    ...mapState("vobDocuments", {
      vobSendIsFetching: state => state.vobSendIsFetching,
    }),
    paginationContacts: {
      set: function (value) {
        this.searchFavoriteContacts(value);
      },
      get: function () {
        return this.$store.state.getFavoriteContacts.pagination;
      }
    },
  },
  methods: {
    ...mapActions("getHeadersFavoriteContacts", ["getHeadersFavoriteContacts"]),
    ...mapActions("deleteFavoriteContact", ["deleteFavoriteContact", "updateVisibleModalDeleteFavoriteContact"]),
    ...mapActions("updateFavoriteContact", ["updateFavoriteContact"]),
    ...mapActions("getFavoriteContacts", ["getFavoriteContacts"]),
    ...mapActions("saveProjectEntry", ['storeProjectEntry']),
    ...mapActions("updateVisibleFavoriteContactFormModal", ["updateFavoriteContactFormModal"]),
    ...mapActions('sendInvoice', ["sendInvoice"]),
    ...mapActions("sendDocument", ["sendDocument"]),
    ...mapActions("sendTimeReport", ["sendTimeReport"]),
    ...mapActions("vobDocuments", ["saveVobDocumentRequest"]),

    searchFavoriteContacts: function (valueSearch = {}, filters = false) {
      valueSearch.language = this.getCurrentLanguage;
      valueSearch.filters = filters;
      valueSearch.contactableType = this.contactableType;
      this.getFavoriteContacts({valueSearch});
      if (filters) {
        this.currentPage = 1;
      }
    },
    editContact: function(id) {
      this.updateFavoriteContactFormModal(true);
      setTimeout( () => {eventBus.$emit("setFavoriteContactId", id)}, 5);
       // bez timeoutu sie dane nie pojawiaja za pierwszym kliknieciem
       // chyba dlatego ze Form wtedy nie jest wyrenderowany i wiec nie ma jak wylapac eventu
    },
    removeContact: function (index, id) {
      this.favoriteContacts.splice(index, 1);
      this.deleteFavoriteContact({creds: {id}});
    },
    showDeleteFavoriteContactModal: function (item) {
      this.contactToDelete = item;
      this.updateVisibleModalDeleteFavoriteContact(true);
    },
    hideModalContact: function () {
      this.updateVisibleModalDeleteFavoriteContact(false);
    },
    sendEmail(item) {
      switch(this.emailType) {
        case "invoice":
          this.sendInvoice({creds: {
            email: item.email,
            invoice: this.invoice,
            favoriteContact: item
          }});
          break;
        case "document":
          this.favoriteContact = item;
          this.showSendDocumentFormModal = true;
          break;
        case "timeReport":
          this.sendTimeReport({
            creds: {
              email: item.email,
              timeReport: this.timeReport,
              favoriteContact: item
            }
          });
          break;
        case "vobDocument":
          this.saveVobDocumentRequest({creds: {
              'sendEmail': true,
              'email': item.email,
            }})
          break;
      }

    },
    hideSendDocumentForm() {
      this.showSendDocumentFormModal = false;
    }
  },
  mounted() {
    const language = this.getCurrentLanguage;

    this.getHeadersFavoriteContacts({creds: {language}});

    eventBus.$on("setDisablePagination", (value) => {
      this.footerOptions.disablePagination = value;
    });

    eventBus.$on("getContactsSuccess", (data) => {
      this.favoriteContacts = data;
    });

    eventBus.$on("saveFavoriteContactSuccess", () => {
      this.searchFavoriteContacts({});
    });

    eventBus.$on("deleteFavoriteContactSuccess", () => {
      this.searchFavoriteContacts({});
    });

    eventBus.$on("getFavoriteContacts", () => {
      this.favoriteContacts = [];
      this.searchFavoriteContacts({});
    });

    eventBus.$on("sendDocumentSuccess", () => {
      this.showSendDocumentFormModal = false;
    });
  },
  beforeDestroy() {
    eventBus.$off('deleteFavoriteContactSuccess');
    eventBus.$off('saveFavoriteContactSuccess');
  }

}
</script>